<script lang="ts">
    import ProductsChart from "../Components/EmployeePurchasesActions/EmployeePurchasesReport/ProductsChart.svelte";
    import PurchaseTable from "../Components/EmployeePurchasesActions/EmployeePurchasesReport/PurchaseTable.svelte";
    import ReportHeader from "../Components/EmployeePurchasesActions/EmployeePurchasesReport/ReportHeader.svelte";
    import Toolbar from "../Components/EmployeePurchasesActions/EmployeePurchasesReport/Toolbar.svelte";

    export let params: { id?: string } = {};
</script>

<section class="getSummaryReport">
    <ReportHeader employeeID={params.id} />
    <PurchaseTable employeeID={params.id} />
    <section class="productsChart">
        <ProductsChart employeeID={params.id} />
    </section>
    <Toolbar />
</section>

<style lang="scss">
    .getSummaryReport {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 100vh;

        .productsChart {
            margin: {
                top: 2rem;
                bottom: 1rem;
            }
            width: 450px;
        }
    }
</style>